module.exports = __webpack_public_path__ + "img/slide-5.e360e80a.png";